<template>
  <div>
    <Header />
    <main role="main" id="main_app">
      <slot />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import FooterNew from '@/components/FooterNew'

export default {
  components: {
    Header,
    Footer,
    FooterNew
  }
}
</script>
<style lang="scss" scoped>
#main_app {
  min-height: calc(100vh - 204px);
}
#main_app {
  position: relative;
  .go-back {
    position: absolute;
    padding: 13px 10px;
  }
}
</style>